<template>
  <div class="main-container">
    <Header :meta="dataMeta" />
    <!-- Content -->
    <div class="container-fluid">
      <div class="section_information_merchant mb-4">
        <div class="card card_information">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 border-right">
                <div class="row">
                  <div class="col-md-3 ">
                    <img
                      :src="detail_profile.avatar"
                      class="img-fluid center"
                      alt=""
                    />
                  </div>
                  <div class="col-md-9">
                    <div class="information_merchant">
                      <div class="d-flex align-items-center">
                        <label for="">{{
                          detail_profile == Object
                            ? "Toko belum tersedia"
                            : detail_profile.name
                        }}</label>
                        <button
                          @click="getOpenModalProfile()"
                          class="ml-2 mb-2 btn btn-edit"
                        >
                          <i class="font-size-14 fa fa-pencil"></i>
                        </button>
                      </div>
                      <div class="penjual">
                        <span class="title">Penjual :</span>
                        <span class="ml-2 formal_name">{{
                          detail_profile.owner ? detail_profile.owner.name : "-"
                        }}</span>
                      </div>
                      <div class="penjual">
                        <span class="title">Kelas :</span>
                        <span class="ml-2 formal_name">{{
                          detail_profile.owner
                            ? detail_profile.owner.class.class_room
                            : `-`
                        }}</span>
                      </div>
                      <div class="penjual">
                        <span class="title">Jurusan :</span>
                        <span class="ml-2 formal_name">{{
                          detail_profile.owner
                            ? detail_profile.owner.major
                            : "-"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-3 border-right">
                    <!-- <div class="rating text-center">
                      <label>Rating toko</label>
                      <div class="rating_count center">
                        <img
                          :src="
                            require('@/assets/images/kewirausahaan/rate.png')
                          "
                          alt=""
                        />
                        <span
                          class="rating_information ml-2 font-weight-bold"
                          >{{ detail_profile.sales_rating }}</span
                        >
                      </div>
                    </div> -->
                  </div>
                  <div class="col-md-3 border-right">
                    <!-- <div class="terjual text-center">
                      <label>Terjual</label>
                      <div class="rating_count center">
                        <span
                          class="rating_information ml-2 font-weight-bold"
                          >{{ detail_summary.history_order }}</span
                        >
                      </div>
                    </div> -->
                  </div>
                  <div class="col-md-4 border-right">
                    <!-- <div class="terlaris">
                      <label>Terlaris</label>
                      <label class="float-right text-success underline"
                        >Cek produk</label
                      >
                      <div class="card">
                        <div class="card-body d-flex align-items-center">
                          <img
                            class="img_popular"
                            :src="detail_profile.avatar"
                            alt=""
                          />
                          <div class="terjual">
                            <span class="font-weight-bold"
                              >Terjual {{ detail_summary.incoming_order }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="col-md-2">
                    <div class="terjual text-center">
                      <label>Jumlah Produk</label>
                      <div class="rating_count center">
                        <span
                          class="rating_information ml-2 font-weight-bold"
                          >{{ detail_summary.product }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="create_merchant mb-4">
        <div class="row">
          <div class="col-md-6 col-lg-6">
            <div class="float-left">
              <a
                href="javascript:void(0);"
                data-toggle="tab"
                role="tab"
                class="btn btn-outline-success btn-sm pl-4 pt-2 pb-2 pr-4 mr-2"
                :class="tab === `produk_saya` ? `active` : `non_active`"
                @click="tab = 'produk_saya'"
                >Produk Saya</a
              >
              <a
                href="javascript:void(0);"
                data-toggle="tab"
                role="tab"
                class="btn btn-outline-success btn-sm pl-4 pt-2 pb-2 pr-4"
                :class="tab === `toko_saya` ? `active` : `non_active`"
                @click="tab = 'toko_saya'"
                >Toko Saya</a
              >
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="float-right">
              <button
                v-if="messageError.length > 0"
                disabled
                class="btn w-100 show-all text-white btn-primary-theme-green font-weight-bold"
              >
                Tambah Produk Baru
              </button>
              <button
                v-else
                @click="getOpenModalCreateProduct()"
                class="btn w-100 show-all text-white btn-primary-theme-green font-weight-bold"
              >
                Tambah Produk Baru
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mb-5"
        v-if="tab === 'produk_saya'"
        :class="tab === `produk_saya` ? `show` : `fade`"
      >
        <div class="item">
          <div class="row">
            <div
              :loading="isLoading"
              class="col-md-2 col-xs-4 col-lg-2 mb-4 mt-5"
              v-for="(item, index) in item_seller"
              :key="`item_seller_${index}`"
            >
              <div class="row mb-2">
                <div class="col-md-12">
                  <div class="float-right">
                    <button
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Hapus Produk"
                      class="btn btn-outline-secondary mr-2"
                      @click="getDetailProduct(item.id)"
                    >
                      <i class="font-size-20 fa fa-pencil"></i>
                    </button>
                    <button
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Hapus Produk"
                      class="btn btn-outline-danger"
                      @click="submitDeleteProduct(item.id)"
                    >
                      <i class="font-size-20 fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
              </div>
              <router-link
                :to="`/kewirausahaan/detail-barang/${item.id}`"
                class="card"
              >
                <div
                  class="image"
                  :style="{
                    background: 'url(' + item.image + ')',
                  }"
                ></div>
                <div class="content">
                  <!-- name brand -->
                  <div>
                    <div class="brand">
                      <div class="name">
                        {{
                          item.name.length > 50
                            ? item.name.slice(0, 50) + `...`
                            : item.name
                        }}
                      </div>
                    </div>

                    <div class="title">
                      {{ item.description.slice(0, 18) + `...` }}
                    </div>
                  </div>
                  <!-- rating and count sold -->
                  <!-- <div class="row">
                    <div class="col-6 border-right">
                      <div class="rating d-flex aling-items-center">
                        <img
                          :src="
                            require('@/assets/images/kewirausahaan/rate.png')
                          "
                          alt=""
                        />
                        <p class="ml-2 rating-number">
                          {{ item.rating.length > 0 ? item.rating : `-` }}
                        </p>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="sold">Terjual {{ item.sold }}</div>
                    </div>
                  </div> -->
                  <div class="row mt-2 mb-2">
                    <div class="col-12">
                      <div class=" border-bottom"></div>
                    </div>
                  </div>
                  <!-- price -->
                  <div class="row">
                    <div class="col-12">
                      <div class="price">Rp{{ formatNumber(item.price) }}</div>
                    </div>
                  </div>
                  <!-- location -->
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="tab === 'toko_saya'"
        :class="tab === `toko_saya` ? `show` : `fade`"
      >
        <TokoPribadi :detail_toko="detail_profile" />
      </div>
    </div>

    <!-- Modal create update nama toko -->
    <b-modal scrollable v-model="showDataProfile" title="Profile toko">
      <form ref="form" @submit.prevent="submitProfileToko">
        <b-form-group
          :label="formTokoProfile.id ? 'Ganti nama toko' : 'Nama toko'"
          label-for="name-input"
          invalid-feedback="Nama toko wajib diisi"
          :state="nameState"
        >
          <b-form-input
            id="name-input"
            v-model="formTokoProfile.nama_toko"
            placeholder="Nama Toko"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          v-if="formTokoProfile.id"
          label="Foto toko"
          label-for="name-input"
          invalid-feedback="Foto toko wajib diisi"
        >
          <div v-if="previewAvatar">
            <img
              class="img-fluid image-preview center"
              :src="previewAvatar"
              alt=""
            />
          </div>

          <input
            type="file"
            multiple
            hidden
            class="w-100"
            id="upload"
            ref="file"
            @change="onFileChangedAvatar"
          />
          <label for="upload" class="btn-upload">Upload Foto</label>
        </b-form-group>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            class="float-right btn btn-primary-theme-green"
            @click="submitProfileToko()"
          >
            Simpan
          </b-button>
          <b-button
            variant="light"
            size="sm"
            class="float-right mr-2"
            @click="getCloseModalProfile()"
          >
            Close
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Modal create produk -->
    <b-modal scrollable v-model="showModalCreateProduct" title="Produk Toko">
      <form ref="form" @submit.prevent="submitProductToko">
        <div v-if="formCreateProduct.preview_image">
          <img
            class="img-fluid image-preview center"
            :src="formCreateProduct.preview_image"
            alt=""
          />
        </div>
        <input
          type="file"
          multiple
          hidden
          class="w-100"
          id="upload"
          ref="file"
          @change="onFileChanged"
        />
        <label for="upload" class="btn-upload">Upload Foto</label>

        <b-form-group label="* Nama Produk :">
          <b-form-input
            v-model="formCreateProduct.product_name"
            type="text"
            placeholder="Nama produk"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="* Deskripsi Produk :"
          label-for="input-1"
        >
          <b-form-textarea
            id="textarea-small"
            v-model="formCreateProduct.description"
            size="sm"
            placeholder="Deksripsikan produk anda"
          ></b-form-textarea>
        </b-form-group>
        <div class="row">
          <div class="col-md-6">
            <b-form-group
              id="input-group-1"
              label="* Harga :"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="formCreateProduct.price"
                type="number"
                placeholder="Contoh : 20000"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              id="input-group-1"
              label="* Stok :"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="formCreateProduct.stock"
                type="number"
                placeholder="Stok produk"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-form-group
          id="input-group-1"
          label="* Kategori :"
          label-for="input-1"
        >
          <select
            v-model="formCreateProduct.category_id"
            class="custom-select"
            placeholder="Provinsi"
            @change="getSubCategoryProduct()"
            required
          >
            <option
              v-for="(item, index) in category"
              :key="index"
              :value="item.id"
              >{{ item.name }}</option
            >
          </select>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="* Sub Kategori :"
          label-for="input-1"
        >
          <select
            v-model="formCreateProduct.sub_category_id"
            class="custom-select"
            placeholder="Provinsi"
            required
          >
            <option
              v-for="(item, index) in sub_category"
              :key="index"
              :value="item.id"
              >{{ item.name }}</option
            >
          </select>
        </b-form-group>

        <b-form-checkbox
          id="checkbox-1"
          name="checkbox-1"
          value="1"
          v-model="formCreateProduct.published"
          unchecked-value="0"
        >
          Status Penayangan
        </b-form-checkbox>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            class="float-right btn btn-primary-theme-green"
            @click="submitProductToko()"
          >
            {{ formCreateProduct.id ? "Ubah" : "Simpan" }}
          </b-button>
          <b-button
            variant="light"
            size="sm"
            class="float-right mr-2"
            @click="getCloseModalCreateProduct()"
          >
            Close
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- <b-button @click="getOpenModalProfile()" variant="primary"
      >Show Modal</b-button
    > -->

    <!-- Content -->
    <Footer bgFooter="old-blue-bg" :meta="dataMeta" />

    <OffCanvasMobileMenu :meta="dataMeta" />
  </div>
</template>
<script>
import broker from "../../utils/broker";
import Header from "../../components/header-top-fix-green";
import Footer from "../../components/footer-green";
import OffCanvasMobileMenu from "@/components/off-canvas-mobile-menu-green";
import numeral from "numeral";
import VueElementLoading from "vue-element-loading";
import TokoPribadi from "@/components/sections/KewirausahaanGreen/TokoPribadi";
export default {
  props: ["dataMeta"],
  name: "TokoSaya",
  data() {
    return {
      isLoading: false,
      isLoadingProfile: false,
      showDataProfile: false,
      showModalCreateProduct: false,
      item_seller: [],
      tab: "produk_saya",
      fileAvatar: null,
      previewAvatar: null,
      formTokoProfile: {
        id: null,
        nama_toko: "",
      },
      messageError: "",
      formCreateProduct: {
        id: null,
        product_name: "",
        description: "",
        price: null,
        stock: null,
        published: 0,
        category_id: null,
        sub_category_id: null,
        file: null,
        preview_image: null,
      },
      category: [],
      sub_category: [],
      nameState: null,
      detail_profile: Object,
      detail_summary: Object,
    };
  },
  components: {
    Header,
    Footer,
    OffCanvasMobileMenu,
    TokoPribadi,
    VueElementLoading,
  },
  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Toko Saya`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  async mounted() {
    if (this.$store.state.token === "") {
      this.$router.push(`/`);
    } else {
      await this.getProfileToko();
      if (this.formTokoProfile.nama_toko != "") {
        await this.getListGoodiesMerchant();
      } else {
        this.getOpenModalProfile();
      }
    }
  },
  methods: {
    async getProfileToko() {
      this.isLoadingProfile = true;
      await broker.fetch
        .get(`/mobile/enterpreneur/merchants/account/profiles`)
        .then((response) => {
          let message = "Selamat Datang !";
          this.detail_profile = response.data.data;
          this.formTokoProfile.nama_toko = response.data.data.name;
          this.formTokoProfile.id = response.data.data.id;
          this.previewAvatar = response.data.data.avatar;
          this.$Toast.fire({
            title: message,
            icon: "success",
          });
          this.isLoadingProfile = false;
          this.getProfileTokoSummary();
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoadingProfile = false;
            this.messageError = message;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
          }
        });
    },
    async getProfileTokoSummary() {
      this.isLoading = true;

      await broker.fetch
        .get(`/mobile/enterpreneur/merchants/account/profile/summary`)
        .then((response) => {
          this.detail_summary = response.data.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoading = false;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
            this.getOpenModalProfile();
          }
        });
    },
    async getListGoodiesMerchant() {
      this.isLoading = true;

      await broker.fetch
        .get(`/mobile/enterpreneur/merchants/account/profile/goodies-all`)
        .then((response) => {
          response.data.data.forEach((item) => {
            this.item_seller.push(item);
          });
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoading = false;
            // this.$Toast.fire({
            //   title: message,
            //   icon: "error",
            // });
            this.getOpenModalProfile();
          }
        });
    },
    async getCategoryProduct() {
      await broker.fetch
        .get(`/mobile/enterpreneur/category`)
        .then((response) => {
          response.data.data.forEach((item) => {
            this.category.push(item);
          });
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
          }
        });
    },
    async getSubCategoryProduct() {
      await broker.fetch
        .get(
          `/mobile/enterpreneur/category/${this.formCreateProduct.category_id}/detail`
        )
        .then((response) => {
          response.data.data.forEach((item) => {
            this.sub_category.push(item);
          });
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
          }
        });
    },
    async getOpenModalCreateProduct() {
      this.showModalCreateProduct = true;
      this.formCreateProduct.id = null;
      this.formCreateProduct.product_name = "";
      this.formCreateProduct.description = "";
      this.formCreateProduct.price = null;
      this.formCreateProduct.stock = null;
      this.formCreateProduct.category_id = null;
      this.formCreateProduct.sub_category_id = null;
      this.formCreateProduct.published = 0;
      this.formCreateProduct.preview_image = null;
      await this.getCategoryProduct();
    },
    async getDetailProduct(id) {
      // update
      this.showModalCreateProduct = true;
      await broker.fetch
        .get(`/mobile/enterpreneur/merchants/account/goodies/${id}`)
        .then((response) => {
          this.getCategoryProduct();
          this.formCreateProduct.id = response.data.data.id;
          this.formCreateProduct.product_name = response.data.data.name;
          this.formCreateProduct.description = response.data.data.description;
          this.formCreateProduct.price = response.data.data.price;
          this.formCreateProduct.stock = response.data.data.stock;
          this.formCreateProduct.category_id = response.data.data.category.id;
          this.getSubCategoryProduct();
          this.formCreateProduct.sub_category_id =
            response.data.data.sub_category.id;
          this.formCreateProduct.published = response.data.data.published;
          this.formCreateProduct.preview_image =
            response.data.data.image[0].image;
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoadingProfile = false;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
            this.getCloseModalCreateProduct();
          }
        });
    },
    async submitProfileToko() {
      if (!this.checkFormValidity()) {
        return;
      }

      this.isLoading = true;
      this.isLoadingProfile = true;

      let formData = {
        name: this.formTokoProfile.nama_toko,
      };

      let FormDataAvatar = new FormData();

      FormDataAvatar.append("_method", "post");
      FormDataAvatar.append("file", this.fileAvatar);

      if (this.formTokoProfile.id) {
        if (this.fileAvatar) {
          await broker.fetch.post(
            `/mobile/enterpreneur/merchants/account/profiles/image`,
            FormDataAvatar,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          await broker.fetch
            .put(`/mobile/enterpreneur/merchants/account/profiles`, formData)
            .then((response) => {
              let response_data = response;
              this.$Toast.fire({
                title: `Toko berhasil diupdate `,
                icon: "success",
              });
              this.getProfileToko();
              this.getCloseModalProfile();
              this.isLoading = false;
              this.isLoadingProfile = false;
            })
            .catch((error) => {
              if (error.response) {
                let message = error.response.data.error;
                this.isLoading = false;
                this.isLoadingProfile = false;
                this.$Toast.fire({
                  title: message,
                  icon: "error",
                });
              }
            });
        } else {
          await broker.fetch
            .put(`/mobile/enterpreneur/merchants/account/profiles`, formData)
            .then((response) => {
              let response_data = response;
              this.$Toast.fire({
                title: `Toko berhasil diupdate `,
                icon: "success",
              });
              this.getProfileToko();
              this.getCloseModalProfile();
              this.isLoading = false;
              this.isLoadingProfile = false;
            })
            .catch((error) => {
              if (error.response) {
                let message = error.response.data.error;
                this.isLoading = false;
                this.isLoadingProfile = false;
                this.$Toast.fire({
                  title: message,
                  icon: "error",
                });
              }
            });
        }
      } else {
        await broker.fetch
          .post(`/mobile/enterpreneur/merchants`, formData)
          .then((response) => {
            let response_data = response;
            this.$Toast.fire({
              title: `Toko berhasil dibuat  `,
              icon: "success",
            });
            this.getProfileToko();
            this.getListGoodiesMerchant();
            this.getCloseModalProfile();
            this.isLoading = false;
            this.isLoadingProfile = false;
          })
          .catch((error) => {
            if (error.response) {
              let message = error.response.data.error;
              this.isLoading = false;
              this.isLoadingProfile = false;

              this.$Toast.fire({
                title: message,
                icon: "error",
              });
            }
          });
      }
    },
    async submitProductToko() {
      if (this.formCreateProduct.id) {
        let formData = {
          name: this.formCreateProduct.product_name,
          description: this.formCreateProduct.description,
          price: this.formCreateProduct.price,
          stock: this.formCreateProduct.stock,
          published: this.formCreateProduct.published,
          enterpreneur_category_id: this.formCreateProduct.category_id,
          enterpreneur_sub_category_id: this.formCreateProduct.sub_category_id,
        };

        await broker.fetch
          .put(
            `/mobile/enterpreneur/merchants/account/goodies/update/${this.formCreateProduct.id}`,
            formData
          )
          .then((response) => {
            let message = `Produk berhasil diupdate`;
            this.$Toast.fire({
              title: message,
              icon: "success",
            });
            this.item_seller = [];
            this.getListGoodiesMerchant();
            this.getCloseModalCreateProduct();
          })
          .catch((error) => {
            if (error.response) {
              let message = error.response.data.error;
              this.isLoading = false;
              this.$Toast.fire({
                title: message,
                icon: "error",
              });
            }
          });
      } else {
        let formData = new FormData();
        formData.append("_method", "post");
        formData.append("name", this.formCreateProduct.product_name);
        formData.append("description", this.formCreateProduct.description);
        formData.append("price", this.formCreateProduct.price);
        formData.append("stock", this.formCreateProduct.stock);
        formData.append("published", this.formCreateProduct.published);
        formData.append(
          "enterpreneur_category_id",
          this.formCreateProduct.category_id
        );
        formData.append(
          "enterpreneur_sub_category_id",
          this.formCreateProduct.sub_category_id
        );
        formData.append("file[0]", this.formCreateProduct.file);

        await broker.fetch
          .post(
            `/mobile/enterpreneur/merchants/account/goodies/create`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((response) => {
            let message = `Produk berhasil dibuat`;
            this.$Toast.fire({
              title: message,
              icon: "success",
            });
            this.item_seller = [];
            this.getListGoodiesMerchant();
            this.getCloseModalCreateProduct();
          })
          .catch((error) => {
            if (error.response) {
              let message = error.response.data.error;
              this.isLoading = false;
              this.$Toast.fire({
                title: message,
                icon: "error",
              });
            }
          });
      }
    },
    async submitDeleteProduct(id) {
      this.isLoading = true;
      await broker.fetch
        .delete(`/mobile/enterpreneur/merchants/account/goodies/delete/${id}`)
        .then((response) => {
          let message = "Data berhasil di hapus";
          let response_data = response;
          this.$Toast.fire({
            title: message,
            icon: "success",
          });
          this.item_seller = [];
          this.getListGoodiesMerchant();
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoading = false;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
          }
        });
    },

    formatNumber(value) {
      let formatted = numeral(value).format("0,0");
      return formatted;
    },
    getOpenModalProfile() {
      this.showDataProfile = true;
    },
    getCloseModalProfile() {
      this.showDataProfile = false;
    },
    getCloseModalCreateProduct() {
      this.showModalCreateProduct = false;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    onFileChanged() {
      this.formCreateProduct.file = this.$refs.file.files[0];
      this.formCreateProduct.preview_image = URL.createObjectURL(
        this.$refs.file.files[0]
      );
    },
    onFileChangedAvatar() {
      this.fileAvatar = this.$refs.file.files[0];
      this.previewAvatar = URL.createObjectURL(this.$refs.file.files[0]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_detail_toko.scss";
@import "@/assets/scss/4-sections/_kewirausahaan_template_2.scss";
.image-preview {
  width: 16rem;
  height: 12rem;
  margin: 0rem 0rem 2rem 0rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.btn-upload {
  display: inline-block;
  background-color: #00a24b;
  color: white;
  padding: 0.4rem;
  font-family: sans-serif;
  font-weight: bold;
  width: 100%;
  border-radius: 0.2rem;
  cursor: pointer;
  text-align: center;
  margin-top: 0rem;
}
.btn-edit {
  background-color: #00a24b; /* Hijau */
  border: none;
  color: white;
  padding: 0px;
  height: 24px;
  width: 24px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: 50%;
}
</style>
